<!-- 我的页面 -->
<template>
  <div class="content-top">
    <div class="breadcrumb-info">
      <a-breadcrumb v-if="breadcrumb.length">
        <a-breadcrumb-item><a href="javascript:;">{{breadcrumb[0]}}</a></a-breadcrumb-item>
        <a-breadcrumb-item><a href="javascript:;">{{breadcrumb[1]}}</a></a-breadcrumb-item>
        <a-breadcrumb-item v-if="breadcrumb[2]">{{breadcrumb[2]}}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="user-info">
      <!-- <a-button type="primary" >Meta投放平台</a-button> -->
      <a-button type="primary" ghost size="small" style="margin-left:10px" @click="turnToBI">
        <img src="@/assets/images/icon-wrapper.svg" width="14" alt />
        <span style="margin-left:5px;font-size: 12px;">前往CyberMedia工作台</span>
      </a-button>
      <a-tooltip :visible="tipVisible" placement="bottom" title="我先藏在这里咯!">
        <a-tooltip :trigger="tipVisible?'contextmenu':'hover'">
          <template slot="title">
            <span style="font-size: 12px">帮助中心</span>
          </template>
          <i class="vxe-icon-question-circle-fill top-help-btn" @click="btnClick('help_center_btn', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/1-fen-zhong-shi-pin-jie-shao')"></i>
        </a-tooltip>
      </a-tooltip>
      <a-dropdown v-model="flag" placement="bottomCenter">
        <div class="user-name">{{name}}<icon-font :type="flag?'icon-Up':'icon-Down'" class="drop-icon"></icon-font></div>
        <a-menu slot="overlay" class="user-dropdown">
          <!-- <a-menu-item>
            <a href="javascript:;" @click="$router.push({
              name: 'userMessage',
              query: {
                tab: 'message'
              }
            })"><icon-font type="icon-User" style="margin-right: 12px"/>基本信息</a>
          </a-menu-item>
          <a-menu-item>
            <a href="javascript:;" @click="$router.push({
              name: 'userMessage',
              query: {
                tab: 'password'
              }
            })"><icon-font type="icon-Key" style="margin-right: 12px"/>修改密码</a>
          </a-menu-item> -->
          <a-menu-item>
            <a href="javascript:;" @click="logout"><icon-font type="icon-Export" style="margin-right: 12px"/>退出登录</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <a-modal
      v-model="visible"
      width="640px"
      :centered="true"
      @cancel="handleOk"
      class="welcome-modal"
    >
      <div class="t-center">
        <div class="title">欢迎来到CyberAnalytics!</div>
        <div class="discription">CyberAnalytics可以查看多媒体多账号的投放效果，也可以一键复制模版生成您的专属日报,</div>
        <div class="discription">快来开启您的高效分析之旅吧！</div>
        <a-row :gutter="40" class="handle-box">
          <a-col :span="8">
            <div class="btn" @click="btnClick('video_introduction', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/1-fen-zhong-shi-pin-jie-shao')">
              <img src="@/assets/images/welcome/video.png" alt="" srcset="">
              <div>1分钟看一下<br>视频介绍</div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="btn" @click="btnClick('operation_manual', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/2-fen-zhong-cao-zuo-shou-ce')">
              <img src="@/assets/images/welcome/template.png" alt="" srcset="">
              <div>2分钟看一下<br>操作手册</div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="btn" @click="btnClick('daily_template', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/3-bu-sheng-cheng-yi-ge-zhou-bao')">
              <img src="@/assets/images/welcome/handle.png" alt="" srcset="">
              <div>3步生成一个<br>日报模版</div>
            </div>
          </a-col>
        </a-row>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="handleOk">我知道了</a-button>
      </template>
    </a-modal>
    <template v-if="followFlag">
      <div class="follow">
        <div class="weixin">
          <a-tooltip title="帮助中心" placement="left">
            <icon-font type="icon-Question-Circle-Line" @click="btnClick('help_center_btn', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/1-fen-zhong-shi-pin-jie-shao')"></icon-font>
          </a-tooltip>
        </div>
        <div class="line"></div>
        <a-tooltip title="建议和反馈" placement="left">
          <icon-font type="icon-Edit" @click="btnClick('suggestion_btn', 'https://cyberklick.gitbook.io/cybermedia-shou-ce/shu-ju-fen-xi/jian-yi-fan-kui')"></icon-font>
        </a-tooltip>
        <a-tooltip title="收起浮层" placement="left">
          <img @click="followFlag = false" class="fold" src="@/assets/images/welcome/fold.png" alt=""/>
        </a-tooltip>
      </div>
    </template>
    <a-tooltip title="展开浮层" placement="left" :mouseEnterDelay="0.5">
      <div class="follow-fold" @click="followFlag = true">
        <img src="@/assets/images/welcome/folding.png" alt="" srcset="">
      </div>
    </a-tooltip>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapState, mapGetters } from "vuex";
import { logout } from "@/api/user";


export default {
  data() {
    return {
      showServiceFlag: false,
      breadcrumb: [],
      flag: false,
      visible: false,
      followFlag: false,
      tipVisible: false
    };
  },
  computed: {
    ...mapGetters([
      "name",
      // 'avatar'
    ]),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  async created() {
  },
  watch: {
    $route() {
      this.breadcrumb = this.$route.meta.breadcrumb || []
    }
  },
  methods: {
    handleOk() {
      gtag('event', 'welcome_modal_close');
      this.visible = false
      this.tipVisible = true
      setTimeout(() => {
        this.tipVisible = false
      }, 3000);
    },
    // 退出
    logout() {
      this.$store.dispatch('user/logout')
    },
    btnClick(name, url) {
      gtag('event', name);
      window.open(url, '__blank')
    },
    turnToBI() {
      if (window.location.host.includes("cyberklick")) {
        location.href = this.userInfo.innerFlag == 1?'https://media.cyberklick.com.cn/dashboard':'https://business.cyberklick.com.cn/dashboard'
      } else {
        location.href = this.userInfo.innerFlag == 1?'http://test.media.yeahmobi.com/':'http://test.business.yeahmobi.com/'
      }
    },
  },
  mounted() {
    this.breadcrumb = this.$route.meta.breadcrumb || []
    let f = localStorage.getItem(`welcome${this.userInfo.id}`)
    this.visible = f !== '1'
    localStorage.setItem(`welcome${this.userInfo.id}`, '1')
  }
};
</script>

<style lang="less">
.ant-dropdown {
  border-radius: 6px;
}
.user-dropdown {
  min-width: 124px;
}
.top-help-btn {
  font-size: 20px;
  color: #677392;
  vertical-align: middle;
  margin-left: 16px;
  cursor: pointer;
}
.welcome-modal {
  .ant-modal {
    max-width: 640px;
  }
  .ant-modal-content {
    background: url(../../assets/images/welcome/background.png) no-repeat center center;
  }
  .title {
    font-weight: 500;
    color: #2D3446;
    font-size: 24px;
    line-height: 32px;
    margin-top: 16px;
    margin-bottom: 12px;
  }
  .discription {
    font-weight: 400;
    color: #677392;
    line-height: 22px;
    font-size: 14px;
  }
  .handle-box {
    width: 504px;
    margin: auto!important;;
    margin-top: 32px!important;
    & > * {
      line-height: 100px;
      color: #2D3446;
      line-height: 24px;
      img {
        width: 56px;
        height: 56px;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .btn {
        font-size: 16px;
        font-weight: 500;
        border: 1px solid #FFFFFF;
        background: rgba(255,255,255,0.52);
        box-shadow: 1px 4px 32px 0px rgba(60,138,99,0.08);
        border-radius: 8px 8px 8px 8px;
        cursor: pointer;
        height: 168px;
      }
    }
  }
  .ant-modal-footer {
    text-align: center;
    padding-top: 32px;
    padding-bottom: 40px;
    .ant-btn {
      font-weight: 400;
      color: #FFFFFF;
      font-size: 16px;
      padding: 8px 54px;
      line-height: 24px;
      height: auto;
    }
  }
}
.follow{
  width: 40px;
  height: 132px;
  background: #FFFFFF;
  border-radius: 12px 0px 0px 12px;
  opacity: 1;
  position: fixed;
  bottom: 70px;
  right: 0px;
  z-index: 9998;
  padding: 4px;
  padding-top: 6px;
  box-sizing: border-box;
  box-shadow: 0px 12px 48px 16px rgba(19,35,76,0.03), 0px 9px 28px 0px rgba(19,35,76,0.05), 0px 6px 16px -8px rgba(19,35,76,0.08);
  text-align: center;
  .anticon {
    font-size: 20px;
    color: #2D3446;
    &:hover {
      color: #22ac35;
    }
  }
  div{
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    img{
      width: 20px;
      height: 20px;
      display: inline-block;
    }

  }
  .line {
    height: 1px;
    background: #E1E8F9;
  }
  .weixin:hover{
    .code{
      display: block;
    }
    .weixin_hover{
      display: inline-block;
    }
    .weixin{
      display: none;
    }
  }
  .call-me:hover{
    .callme_hover{
      display: inline-block;
    }
    .callme{
      display: none;
    }
  }
  .fold {
    cursor: pointer;
    width: 32px;
    height: 32px;
    margin-top: 12px;
  }
}
  .follow-fold {
    width: 46px;
    height: 48px;
    position: fixed;
    right: -16px;
    bottom: 70px;
    transition: right 0.5s;
    z-index: 1111;
    &:hover {
      right: 0;
    }
    img {
      height: 48px;
      width: 46px;
      object-fit: contain;
      cursor: pointer;
      // box-shadow: 0px 12px 48px 16px rgba(19,35,76,0.03), 0px 9px 28px 0px rgba(19,35,76,0.05), 0px 6px 16px -8px rgba(19,35,76,0.08);
    }
  }
</style>
